import TransactionAPI from '@/app/apis/main/transaction/transaction-api.js';

export default {
	/**
	 * @param {*} queryParams
	 */
	async getCustomerOrderList(queryParams) {
		return TransactionAPI.getCustomerOrderList(queryParams);
	},

	/**
	 * @return {object} order data
	 * @param orderId
	 **/
	async getTransactionOrderById(queryParams) {
		return TransactionAPI.getTransactionOrderById(queryParams);
	},

	/**
	 * 
	 * @param {Integer} orderId 
	 * @returns order object
	 */
	async getTransactionDogOrderById(orderId) {
		return TransactionAPI.getTransactionDogOrderById(orderId);
	},

	/**
	 * 
	 * @param {String} queryParams 
	 * @returns {object} order data
	 */
	async getCustomerDogOrderHistoryList(queryParams) {
		return TransactionAPI.getCustomerDogOrderHistoryList(queryParams);
	},

	/**
	 * @return No content
	 * @param orderId
	 * @param petId
	 * @param body - reason
	 */
	async putCancelOrder(orderId, petId, body) {
		return TransactionAPI.putCancelOrder(orderId, petId, body);
	},

	/**
	 * 
	 * @param {Integer} orderId 
	 * @param {Object} body 
	 * @returns 
	 */
	async putCancelDogOrder(orderId, body) {
		return TransactionAPI.putCancelDogOrder(orderId, body);
	},

	/**
	 * @return {Object} Count
	 * @param petId
	 **/
	async getPendingOrdersCount(petId) {
		return TransactionAPI.getPendingOrdersCount(petId);
	},

	/**
	 * 
	 * @returns 
	 */
	async getPendingDogOrdersCount() {
		return TransactionAPI.getPendingDogOrdersCount();
	},

	/**
	 * @returns 
	 * @param orderId
	 */
	async updateProductOrderStatus(orderId, body) {
		return TransactionAPI.updateProductOrderStatus(orderId, body);
	},

	/**
	 * @param {*} queryParams
	 */
	async getCustomerSubscriptionList(queryParams) {
		return TransactionAPI.getCustomerSubscriptionList(queryParams);
	},
}